import { render, staticRenderFns } from "./pinboard.vue?vue&type=template&id=4491a0a4&"
import script from "./pinboard.vue?vue&type=script&lang=js&"
export * from "./pinboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports